'use client'
import { useEffect } from 'react'

const APartnersScroll = () => {
	useEffect(() => {
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

		if (!prefersReducedMotion) {
			const scrollers = document.querySelectorAll('.scroller')

			scrollers.forEach(scroller => {
				scroller.setAttribute('data-animated', 'true')

				const scrollerInner = scroller.querySelector('.scroller__inner')
				if (!scrollerInner) return

				const scrollerContent = Array.from(scrollerInner.children)

				// Duplikovať logá viackrát pre plynulejší scroll
				for (let i = 0; i < 3; i++) {
					// ← duplikovať 3x namiesto 1x
					scrollerContent.forEach(item => {
						const duplicatedItem = item.cloneNode(true) as HTMLElement
						duplicatedItem.setAttribute('aria-hidden', 'true')
						scrollerInner.appendChild(duplicatedItem)
					})
				}
			})
		}
	}, [])

	return null
}

export default APartnersScroll
